import React from 'react';
import './Cart.css'
import {Link} from 'react-router-dom';

const CartTotals = ({value}) => {
    const{cartSubTotal,cartTax, cartTotal, clearCart}=value;
    return (
        <React.Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-10 mt-2 ml-sm-5 ml-md-auto col-sm-8 text-capitalize text-right">
                        <Link to="/" className="btn btn-blue p-2 my-2" onClick={()=>clearCart()}>CLEAR CART</Link>
                        <h5 className="my-3"> Subtotal: <strong>$ {cartSubTotal}</strong></h5>
                        <h5 className="my-3"> Tax: <strong>$ {cartTax}</strong></h5>
                        <h5 className="my-3"> Total: <strong>$ {cartTotal}</strong></h5>
                        <Link to="/" className="btn btn-blue p-2 my-2">CHECK OUT</Link>
                    </div>
                </div>
            </div> 
        </React.Fragment>
    );
}

export default CartTotals;
